import axios from "axios";

export const login = ({ commit }, { username, password }) => {
  const ht = localStorage.getItem("ht");
  return axios
    .post(
      `/auth/loginpos`,
      { username, password },
      { headers: { TERMINAL: ht } }
    )
    .then(function (response) {
      const userData = response.data;
      let pdv = response.data.pdv;
      let pos = response.data.pos;

      commit("SET_LOGINPOS_DATA", userData);
      commit("SET_USER_TOKEN", userData.access_token);
      commit("SET_HEADERS", { pos, pdv, token: userData.access_token });
      // dispatch("setLogoutTimer", userData.expires_in);
      const now = new Date();
      const expirationDate = new Date(
        now.getTime() + userData.expires_in * 1000
      );
      localStorage.setItem("token", userData.access_token);
      localStorage.setItem("expirationDate", expirationDate);
    })
    .catch(function (err) {
      console.error("Failed loging in", err);
      throw err;
    });
};
